module.exports = __webpack_public_path__ + "static/media/LightEnoughtoFloatBookCover.8e6ad4c8.jpg";